


















import { General } from "@/utils/constants";
import { IBookmark } from "@/store/types/bookmark-types";

export default {
  name: "BookmarkList",
  props: {
    bookmarks: {
      type: Array as () => IBookmark[],
      required: true
    }
  },
  data() {
    return {
      General
    };
  }
};
